import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['drawer', 'overlay', 'toggle'];

  static values = { desktop: Boolean };

  connect() {
    this.setupInitialState();
  }

  disconnect() {
    if (!this.desktopValue && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
  }

  setupInitialState() {
    this.isOpen = this.drawerTarget.classList.contains('admin-drawer-open');
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.drawerTarget.classList.add('admin-drawer-open');

    if (this.desktopValue && this.hasToggleTarget) {
      this.toggleTarget.classList.add('admin-drawer-toggle-shifted');
    }

    if (!this.desktopValue) {
      this.overlayTarget.classList.add('admin-drawer-overlay-visible');
      document.body.style.overflow = 'hidden';
    }

    if (this.desktopValue) {
      this.saveState(true);
    }
  }

  close() {
    this.isOpen = false;
    this.drawerTarget.classList.remove('admin-drawer-open');

    if (this.hasToggleTarget) {
      this.toggleTarget.classList.remove('admin-drawer-toggle-shifted');
    }

    if (!this.desktopValue) {
      this.overlayTarget.classList.remove('admin-drawer-overlay-visible');
      document.body.style.overflow = '';
    }

    if (this.desktopValue) {
      this.saveState(false);
    }
  }

  handleOverlayClick(event) {
    if (!this.desktopValue && event.target === this.overlayTarget) {
      this.close();
    }
  }

  saveState(isOpen) {
    fetch('/ad/drawer', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken(),
      },
      body: JSON.stringify({ drawer_open: isOpen }),
    }).catch((error) => {
      console.error('Failed to save drawer state:', error);
    });
  }
}
